import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { PlaybookShort } from "../model/Playbook";
import { PlaybookType } from "../models/PlaybookType";

interface SearchPlaybooksParams {
  query?: string;
  isFavorite?: boolean;
  offset?: number;
  limit?: number;
  type?: PlaybookType;
}

export const useSearchPlaybooks = () => {
  const {
    data: playbooks,
    call,
    isLoading,
    isFailed,
    setData: setPlaybooks,
  } = useApiPrivateRequest<PlaybookShort[]>((response) =>
    response.map((playbook: any) => new PlaybookShort(playbook)),
  );

  const searchPlaybooks = async (params: SearchPlaybooksParams) => {
    params.limit = params.limit ?? 200;
    await call(`/playbooks/search`, "GET", {
      ...params,
    });
  };

  return {
    playbooks,
    searchPlaybooks,
    isLoading,
    isFailed,
    setPlaybooks,
  };
};
